import { type ColumnDef } from "@tanstack/react-table";
import { AppDataTable } from "@/components/ui/app-data-table";

interface GovernanceDataTableProps<TData> {
  columns: ColumnDef<TData, unknown>[];
  data: TData[];
  emptyMessage?: string;
  minWidthClassName?: string;
}

export function GovernanceDataTable<TData>({
  columns,
  data,
  emptyMessage = "No records found.",
  minWidthClassName = "min-w-full",
}: GovernanceDataTableProps<TData>) {
  return (
    <AppDataTable
      columns={columns}
      data={data}
      emptyMessage={emptyMessage}
      minWidthClassName={minWidthClassName}
    />
  );
}
